import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

function LiveApp() {
  const { appId } = useParams();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadApp();
  }, [appId]);

  const loadApp = async () => {
    try {
      const appDoc = await getDoc(doc(db, 'apps', appId));
      
      if (!appDoc.exists()) {
        setError('App not found');
        setLoading(false);
        return;
      }
      
      const app = appDoc.data();
      
      if (!app.content || app.status !== 'live') {
        setError('This app is not published yet');
        setLoading(false);
        return;
      }
      
      setContent(app.content);
    } catch (error) {
      console.error('Error loading app:', error);
      setError('Failed to load app');
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#0F172A'
      }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#0F172A',
        color: 'white',
        fontSize: '1.5rem'
      }}>
        {error}
      </div>
    );
  }

  // Render the app content in a full viewport
  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'auto' }}>
      <iframe
        srcDoc={content}
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        title="Live App"
        sandbox="allow-scripts allow-same-origin allow-forms"
      />
    </div>
  );
}

export default LiveApp;